import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import type { DonationForm } from '@feathr/blackbox';
import type { IModalProps } from '@feathr/components';
import { ConfirmModal, Input } from '@feathr/components';
import { useLocalUrl, useStore } from '@feathr/extender/state';
import { logUserEvents } from '@feathr/hooks';

interface IProps extends IModalProps {
  form: DonationForm;
}

function CreateFormModal({ form, ...props }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const { DonationForms } = useStore();
  const history = useHistory();
  const localUrl = useLocalUrl();

  async function handleCreateForm(): Promise<void> {
    const response = await DonationForms.add(form);
    if (response.isErrored) {
      throw response.error;
    }
    logUserEvents({ started_fundraising_form: { form_id: response.id } });
    history.push(localUrl(response.getItemUrl('edit')));
  }

  return (
    <ConfirmModal
      confirmButtonText={t('Create')}
      onConfirm={handleCreateForm}
      t={t}
      {...props}
      title={t('Create donation form')}
    >
      <Input
        attribute={'name'}
        label={t('Form name')}
        model={form}
        placeholder={t('Enter a name')}
        type={'text'}
      />
    </ConfirmModal>
  );
}

export default observer(CreateFormModal);
